import React from 'react';
import SvgIcon48 from '../svgIcon48';

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */

const BooksIcon = ({ ...others }) => (
  <SvgIcon48
    title="icons / cat / books"
    {...others}
  >
    <g id="Book48-copie" transform="translate(4.000000, 7.000000)">
      <path d="M35.871875,3.43685203 L35.871875,0 C35.871875,0 23.80625,1.20970782 19.5,5.45570217 C15.218125,1.23374175 3.128125,0 3.128125,0 L3.128125,3.43685203 L0,3.05230914 L0,31.596607 L19.5,34 L39,31.596607 L39,3.05230914 L35.871875,3.43685203 Z M33.55625,2.57964185 L33.55625,25.8124411 C26.983125,27.5348728 22.99375,29.2172479 20.71875,30.4590009 L20.71875,7.48256362 L21.125,7.06597549 C23.5625,4.6866164 29.599375,3.2606032 33.55625,2.57964185 Z M5.44375,2.57964185 C9.36,3.27662582 15.478125,4.71866164 17.875,7.06597549 L18.2975,7.48256362 L18.2975,30.4429783 C14.43,28.3920829 8.5475,26.6696513 5.46,25.8204524 L5.44375,2.57964185 Z M2.4375,5.78416588 L3.128125,5.87229029 L3.128125,27.5829406 C6.67590137,28.4871463 10.1719605,29.5782504 13.60125,30.8515551 L2.4375,29.4816211 L2.4375,5.78416588 Z M36.5625,29.4816211 L25.325625,30.8595664 C28.7813953,29.5730333 32.3077937,28.4790983 35.888125,27.5829406 L35.888125,5.85626767 L36.5625,5.78416588 L36.5625,29.4816211 Z" id="Shape"></path>
    </g>
  </SvgIcon48>
);

export default BooksIcon;
